import {ReactNode} from 'react';

export type ComponentChildren = {
  children: ReactNode;
};
